<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <div class="d-flex">
          <div v-for="(item, index) in dataList" :key="index" class="me-3 mb-3">
            <div class="border border-dashed mb-2">
              <img
                  v-for="(imgItem, imgIdex) in item.attachment"
                  :src="imgItem.url"
                  :key="imgIdex"
                  class="img-thumbnail m-2 p-0 rounded"
                  style="width: 100px;height: 100px;"
                  @click="previewFiles(item.attachment, imgIdex)"
              />
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="flex-grow-1">
                <span class="fw-semibold me-2">{{ item.name }}</span>
                <span v-if="statusValid(item.end_at)" class="text-success">({{ $t('page.valid') }})</span>
                <span v-else class="text-danger">({{ $t('page.expired') }})</span>
              </div>
              <div class="flex-shrink-0 d-flex justify-content-end" v-perm="editPermissionCode">
                <i class="ri-edit-2-line fs-3 text-primary me-3 cursor-pointer" @click="edit(item)"></i>
                <i class="ri-delete-bin-line fs-3 text-danger cursor-pointer" @click="delItem(item.id)"></i>
              </div>
            </div>
          </div>
          <div class="border border-dashed d-flex justify-content-center align-items-center cursor-pointer" style="width: 118px;height: 118px;" @click="add" v-perm="editPermissionCode">
            <span class="text-muted text-opacity-25" style="font-size: 3rem;">+</span>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <add-enterprise-qualification ref="enterpriseEdit" :company-id="companyId" @refresh="getList"></add-enterprise-qualification>
    <ImgsViewer ref="qualificationFileView" :images="viewImgs" />
  </div>
</template>
<script>
import addEnterpriseQualification from "@/views/service-company/components/add-enterprise-qualification";
import ImgsViewer from "@/views/widgets/imgs-viewer";
import {companyQualification, deleteCompanyQualification} from "@/service";
import {successMsg, alertError, alertComfirm} from "@/helpers/swal";
import {formatDatetime} from "@/helpers/common";

export default {
  props: {
    editPermissionCode: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      companyId: null,
      editKey: 0,
      viewImgs: [],
      dataList: []
    }
  },
  mounted() {
    this.companyId = this.$route.params.id
    this.getList()
  },
  methods: {
    add() {
      this.editKey  += 1
      this.$refs.enterpriseEdit.open()
    },
    edit(item) {
      this.editKey += 1
      this.$refs.enterpriseEdit.open(item)
    },
    delItem(id) {
      alertComfirm().then(res => {
        if (res) {
          deleteCompanyQualification(id).then(() => {
            successMsg(this.$t('base.delete_success'))
            this.getList()
          }).catch(err => {
            console.log(err)
            alertError(this.$t('base.prompt'), this.$t('page.errorOccurred'))
          })
        }
      })

    },
    previewFiles(files, index) {
      this.viewImgs = files
      this.$refs.qualificationFileView.show(index)
    },
    getList() {
      this.dataList = []
      companyQualification({
        company: this.companyId
      }).then(res => {
        this.dataList = res.payload.results
      })
    },
    // 证书是否有效
    statusValid(end_at) {
      if (!end_at) {
        return true
      }
      const today = formatDatetime(new Date(), 'YYYY-MM-DD')
      return today <= end_at
    }
  },
  components: {
    addEnterpriseQualification,
    ImgsViewer,
  }
}
</script>
